import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import format from '../../helpers/format'

const Styles = require('./TargetDateSeriesCategoriesTable.css')

@CSSModules(Styles, {allowMultiple:true})
export default class TargetDateSeriesCategoriesTable extends Component {
  static propTypes = {
    // the config for this set of IYV categories
    iyvConfigCategories: PropTypes.array.isRequired,
    // the target date series object
    targetDateSeries: PropTypes.object.isRequired,
  }
  constructor(props) {
    super(props)
  }

  render() {
    const { iyvConfigCategories, targetDateSeries } = this.props

    return (
      <div>
        <table styleName='tds-cats-tbl card'>
          <thead>
            <tr>
              {/* <th /> */}
              <th>
                Screen
              </th>
              <th>
                # of holdings
              </th>
              <th>
                % of portfolio
              </th>
            </tr>
          </thead>
          <tbody>
            {
              iyvConfigCategories.map((e, i) => {
                return (
                  <tr key={'cnfg-cats-'+i}>
                    { /* <td>
                      {
                        e.icon ?
                          (
                            <img
                              src={e.icon}
                              alt={e.lbl}
                              styleName='cnfg-cats-icn'
                            />
                          ) :
                          null
                      }
                    </td> */ }
                    <td>
                      {e.lbl}
                    </td>
                    <td>
                      {targetDateSeries[e.cnt]}
                    </td>
                    <td>
                      {format.perc(targetDateSeries[e.wght])}
                    </td>
                  </tr>
                )
              })
            }
          </tbody>
        </table>
      </div>
    )
  }
}